// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__iOej3","selected":"Pagination_selected__-xohG"};